/**
 * Gets the current username from the Redux store on window.store.
 *
 * This is a local implementation that mirrors @saviynt/common's getUsername().
 * A direct re-export (`import { getUsername } from '@saviynt/common'`) is not
 * viable because Jest cannot consume @saviynt/common's Parcel-bundled CJS
 * output — Parcel emits lazy export getters that conflict with Babel's eager
 * binding in the Jest transform pipeline.  At runtime the Parcel bundler
 * resolves @saviynt/common natively, so this duplication only affects the
 * test environment.  Keep this in sync with @saviynt/common's getUsername().
 *
 * @returns {string} The current username, or empty string if unavailable.
 */
export default function getUsername() {
  try {
    const { store } = window;

    if (store) {
      const state = store.getState();
      const username = state?.user?.userInfo?.username;

      if (username) {
        return username;
      }
    }
  } catch (e) {
    // Silently fail — return empty string below
  }

  return '';
}
